import React from 'react';
import pt from 'prop-types';
import { List, Stack } from '@metarouter-private/mr-mui';

import OrgListItem from './OrgListItem';
import EmptyOrgList from './EmptyOrgList';
import useLockedListHeight from './useLockedListHeight';

export default function OrgList({ orgs, search, loading, switching, switchTo }) {
  const { listRef, height } = useLockedListHeight({ loading, search });
  const sizeProps = height === null ? {} : { height };

  return (
    <Stack ref={listRef} {...sizeProps} overflow="auto">
      {orgs.length === 0 ? (
        <EmptyOrgList search={search} loading={loading} />
      ) : (
        <List disablePadding>
          {orgs.map(org => (
            <OrgListItem key={org.id} org={org} switching={switching} switchTo={switchTo} />
          ))}
        </List>
      )}
    </Stack>
  );
}

OrgList.propTypes = {
  orgs: pt.arrayOf(pt.shape({ id: pt.string.isRequired })).isRequired,
  search: pt.string.isRequired,
  loading: pt.bool.isRequired,
  switching: pt.bool.isRequired,
  switchTo: pt.func.isRequired,
};
